module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEEAAAAwCAYAAABOiRchAAAAAXNSR0IArs4c6QAAATRJREFUaEPtmD8uRGEUxX/nexIKpUKhZwlKhUKv0CpmCd4Tu9AIC1BqJCRTjDd2YQFKkbxE4V/mXZkwYrCDe74d3JPv/M69R6W+OUUaCBZI9gJeejRQ1bSRbPb5cYORRQhuLcJUhFK3dxIbWS0RxJmor1eJxa1KWsomxKSPjsdqqGyD/zevRQAsgkX4NId/gkXwT/gOCtvBdrAdbIefm6OZYCaYCWbCPBPq8V6h38l6UvdFxypN+yRYTisCceWO0UUr8FW0PkisJLbDhTgYbZdS7RKkK1oRXf/+euKN0RujN0ZvjL4if0WhwWgwGowGo8FoMP69kpwOTgeng9NhPh2adr1Cm1lLlckbl9Oi9V6wllWEiDh30eqidVa0Nu2zSNgvzvwfDFWa8SER+yihEEHX0x99AMXJWlbLDXudAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu.png
// module id = 01ru
// module chunks = 1